module.exports = __webpack_public_path__ + "static/og-card-044f098d64d0240204f0d2fff961c34a.png";